module.exports = __webpack_public_path__ + "static/img/eyes_03.ffaff05.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/eyes/thumbnail/eyes_03.png
// module id = nblB
// module chunks = 0